import { render } from "./PortfolioHowTo.vue?vue&type=template&id=04926a9b"
import script from "./PortfolioHowTo.vue?vue&type=script&lang=js"
export * from "./PortfolioHowTo.vue?vue&type=script&lang=js"

import "./PortfolioHowTo.vue?vue&type=style&index=0&id=04926a9b&lang=css"
script.render = render

export default script